import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { formatErrorCode } from '../../../adapters/utils/utils.adapter';
import { BOOK_WIDGET_ERROR_CODES } from '../../../constants/error-codes.constants';
import { DefaultLookupResponse } from '../../../models/core-apis/default-lookup.interfaces';
import { DefaultLookupService } from '../../../services/default-lookup.service';
import * as fromErrorHandlerActions from '../../actions/error-handler.actions';
import * as fromPostDataActions from '../../actions/post-data.action';

@Injectable({ providedIn: 'root' })
export class DefaultLookupSearchEffects {
  loadDefaultLookupSearch$ = createEffect(
    (): Observable<Action> =>
      this.DefaultLookupSearchActions$.pipe(
        ofType(fromPostDataActions.LoadDefaultLookupSearch),
        switchMap(() =>
          this.service.getDefaultLookupApi().pipe(
            map((defaultLookupResponse: DefaultLookupResponse) => {
              if (defaultLookupResponse.searchCriteria?.request?.cacheKey) {
                return fromPostDataActions.UpdateSearchPostData({
                  cacheKeySuffix:
                    defaultLookupResponse.searchCriteria?.request?.cacheKey
                });
              }
              return { type: '[Book Widget] No Action' };
            }),
            catchError((error: HttpErrorResponse) => {
              return of(
                fromErrorHandlerActions.HandleError({
                  errorCode: formatErrorCode(
                    BOOK_WIDGET_ERROR_CODES.DEFAULT_LOOKUP_FAILURE,
                    error?.status
                  ),
                  error: BOOK_WIDGET_ERROR_CODES.DEFAULT_LOOKUP_FAILURE
                })
              );
            })
          )
        )
      )
  );

  navigateToSearch$ = createEffect(
    (): Observable<Action> =>
      this.DefaultLookupSearchActions$.pipe(
        ofType(fromPostDataActions.ReadyToNavigateSearch),
        // eslint-disable-next-line complexity
        map((action) => {
          // verify postData exists before navigation
          const storedData = localStorage.getItem(
            `postData${action.cacheKeySuffix}`
          );
          if (!storedData) {
            return { type: '[Book Widget] Navigation Cancelled - No PostData' };
          }
          // TODO: get the refUrl from AEM for dynamic access
          let refUrl = '';
          switch (action.redirectToPage) {
            case 'FLEXIBLE_AIRPORTS':
              refUrl = '/flightsearch/flexible-airports';
              break;
            case 'FLEXIBLE_DATES':
              refUrl = '/flightsearch/flexible-dates';
              break;
            default:
              refUrl = '/flightsearch/search-results';
          }
          window.document.location.href = `${refUrl}?cacheKeySuffix=${
            action.cacheKeySuffix || null
          }`;
          return { type: '[Book Widget] Navigation Complete' };
        })
      ),
    { dispatch: false }
  );

  constructor(
    private DefaultLookupSearchActions$: Actions,
    private service: DefaultLookupService,
    private store: Store
  ) {}
}
